<template>
	<div class="card main">
		<nav>
			<div class="nav-wrapper indigo darken-3">
				<a href="#" class="brand-logo center">Подтвердите_телефон</a>
			</div>
		</nav>
		<div class="card-content">
			<form class="row" @submit.prevent="submit">
				<div class="input-field col s12">
					<input type="text"
					       id="autocomplete-login"
					       @input="setNumber($event.target.value)"
					       :style="($v.number.$dirty
					                    && (!$v.number.required
					                    || !$v.number.numeric))
							                    ? 'border-bottom: 1px solid #d32f2f;'
							                    : null"
					       autocomplete="off"
					       class="autocomplete">
					<label for="autocomplete-login"
					       :style="($v.number.$dirty
					                    && (!$v.number.required
					                    || !$v.number.numeric))
							                    ? 'color: #d32f2f;'
							                    : null">
						Номер телефона без восьмерки
					</label>
					<error-in-auth :field="$v.number"/>
					<error-number-phone :field="$v.number"/>
				</div>
				<button class="waves-effect waves-light btn right indigo darken-3"
				        :class="{disabled: $v.$invalid}">отправить
				</button>
			</form>
		</div>
	</div>
</template>
<script>
	import verificatePhone                             from "../../plugins/controllers/verificatePhone";
	import { required, numeric, maxLength, minLength } from "vuelidate/lib/validators";
	import { mapMutations }                            from "vuex";
	import ErrorInAuth                                 from "./errorInAuth";
	import setRules                                    from "../../assets/setRules";
	import ErrorNumberPhone                            from "./errorNumberPhone";

	export default {
		name:        "verificateForm",
		components:  { ErrorNumberPhone, ErrorInAuth },
		data() {
			return {
				number: ""
			};
		},
		validations: {
			number: {
				required,
				numeric,
				maxLength: maxLength(12),
				minLength: minLength(10)
			}
		},
		methods:     {
			...mapMutations([
				"setMenu",
				"setAuth",
				"setShowMenu",
				"setShowVerificateForm",
				"setShowVerificateCode"
			]),
			setNumber(value) {
				this.number = value;
				this.$v.number.$touch();
			},
			submit() {

				if (!this.$v.$invalid) {
					let arrNum = Array.from(this.number);
					if (arrNum[0] === "8" || arrNum[0] === "7") {
						arrNum.splice(0, 1);
					} else if (arrNum[0] === "+" && arrNum[1] === "7") {
						arrNum.splice(0, 2);
					}
					verificatePhone("7" + arrNum.join(""))
						.then(res => {
							console.log(res);
							if (res.data && res.data.success && res.data.message === "sms sent") {
								setRules(res);
								this.setShowVerificateForm(false);
								this.setShowVerificateCode(true);
								this.$toast.success({
									title:   "Дождитесь sms-сообщение с кодом подтверждения",
									message: `Код подтверждения отправлен на ваш номер: ${this.number}`,
									timeOut: 7000
								});
							} else if (res.data && !res.data.success && res.data.message === "duplicated") {
								this.setShowVerificateCode(false);
								this.setAuth(true);
								this.$toast.error({
									title:   "Произошла ошибка",
									message: `Данный телефон уже зарегистрирован в системе`
								});
							} else if (res.data && !res.data.success) {
								this.setShowVerificateCode(false);
								this.setAuth(true);
								this.$toast.error({
									title:   "Произошла ошибка",
									message: `Вы отправили не корректный номер телефона`
								});
							} else {
								this.setShowVerificateCode(false);
								this.setAuth(true);
								this.$toast.error({
									title:   "Произошла непредвиденная ошибка",
									message: `Попробуйте позднее`
								});
							}
						})
						.catch(e => {
								console.log(e);
								this.$toast.error({
									title:   "Произошла ошибка",
									message: `Скорее всего такой номер существует,
												либо вы вводите его некорректо`,
									timeOut: 7000
								});
							}
						);

				} else {
					console.log(this.$v);
				}
			}
		}
	};
</script>
<style scoped lang="scss">
	.brand-logo {
		font-size: 22px;
	}
	form {
		margin: 0;
	}
	.main {
		position: absolute;
		top: 30%;
		left: 50%;
		transform: translateX(-50%);
		width: 98%;
		overflow: hidden;
	}
	@media screen and (min-width: 550px) {
		.main {
			width: 400px;
		}
	}
	@media screen and (min-width: 1200px) {
		.main {
			width: 600px;
		}
	}
</style>
